import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import { ButtonVariant } from "cms/components/Button/Button.styles";
import RichText from "cms/components/RichText";
import Text from "cms/components/Text";
import TypeFormButton from "cms/components/TypeFormButton";
import { TypeFormButtonVariant } from "cms/components/TypeFormButton/TypeFormButton.styles";
import BannerBottomImageB from "cms/images/banner-bottom-image-b.png";
import BigBannerImageA from "cms/images/banner-image-a.png";
import BannerTopImageB from "cms/images/banner-top-image-b.png";

import {
  BigBannerContainer,
  BigBannerIllustration,
  ButtonsContainer,
  Container,
  Content,
  Illustration,
  IllustrationContainer,
  Link,
  Message,
  Pitch,
  Tagline,
} from "./FloatingProfilesBannerBlock.styles";

export interface FloatingProfilesBannerBlockProps
  extends Queries.SanityFloatingProfilesBannerBlock {}

const FloatingProfilesBannerBlock: React.FC<FloatingProfilesBannerBlockProps> =
  ({
    headline,
    tagline,
    _rawPitch,
    typeFormButton,
    leftButton,
    rightButton,
  }) => (
    <Container>
      <Content $img={BigBannerImageA}>
        <IllustrationContainer>
          <Illustration
            src={BannerTopImageB}
            alt="Professional users' cursors and avatars in Uizard"
          />
        </IllustrationContainer>
        <Message>
          {tagline && <Tagline>{tagline}</Tagline>}
          <Text variant="H1" as="h1">
            {headline}
          </Text>
          <Pitch>
            <RichText text={_rawPitch} />
          </Pitch>

          <ButtonsContainer>
            {typeFormButton?.label && (
              <TypeFormButton
                label={typeFormButton.label}
                variant={typeFormButton.variant as TypeFormButtonVariant}
              />
            )}

            {leftButton?.label && leftButton.url && (
              <Link href={leftButton.url}>
                <Button
                  label={leftButton.label}
                  variant={leftButton.variant as ButtonVariant}
                />
              </Link>
            )}

            {rightButton?.label && rightButton.url && (
              <Link href={rightButton.url}>
                <Button
                  label={rightButton.label}
                  variant={rightButton.variant as ButtonVariant}
                />
              </Link>
            )}
          </ButtonsContainer>
        </Message>
        <IllustrationContainer>
          <Illustration
            src={BannerBottomImageB}
            alt="Professional users' cursors and avatars in Uizard"
          />
        </IllustrationContainer>
        <BigBannerContainer>
          <BigBannerIllustration
            src={BigBannerImageA}
            alt="Professional users' cursors and avatars in Uizard"
          />
        </BigBannerContainer>
      </Content>
    </Container>
  );

export const query = graphql`
  fragment FloatingProfilesBannerBlock on SanityFloatingProfilesBannerBlock {
    _key
    _type
    headline
    tagline
    _rawPitch(resolveReferences: { maxDepth: 5 })
    typeFormButton {
      variant
      label
    }
    leftButton {
      variant
      label
      url
    }
    rightButton {
      variant
      label
      url
    }
  }
`;

export default FloatingProfilesBannerBlock;
